export const offers = [
  {
    id: 1,
    discount: 60,
    place: "Canada",
    img: require("../assets/images/TicketBooking/offer-pic.jpg"),
  },
  {
    id: 2,
    discount: 50,
    place: "Brazile",
    img: require("../assets/images/home/travel-pic.jpeg"),
  },
  {
    id: 3,
    discount: 40,
    place: "America",
    img: require("../assets/images/TicketBooking/offer-pic.jpg"),
  },
  {
    id: 4,
    discount: 30,
    place: "Goa",
    img: require("../assets/images/home/travel-pic.jpeg"),
  },
  {
    id: 5,
    discount: 30,
    place: "Goa",
    img: require("../assets/images/TicketBooking/offer-pic.jpg"),
  },
  {
    id: 6,
    discount: 30,
    place: "Goa",
    img: require("../assets/images/home/travel-pic.jpeg"),
  },
  {
    id: 7,
    discount: 30,
    place: "Goa",
    img: require("../assets/images/TicketBooking/offer-pic.jpg"),
  },
  {
    id: 8,
    discount: 30,
    place: "Goa",
    img: require("../assets/images/home/travel-pic.jpeg"),
  },
  {
    id: 9,
    discount: 30,
    place: "Goa",
    img: require("../assets/images/TicketBooking/offer-pic.jpg"),
  },
];
